<div class="b2b-section content-wrapper">
  <ion-row class="align-items-center ion-justify-content-between">
    <ion-col size="12" size-lg="9">
      <div class="h1">{{ 'b2b.title' | translate }}</div>
      <p>{{ 'b2b.description' | translate }}</p>
    </ion-col>

    <ion-button [routerLink]="['/submit-your-property']">{{ 'b2b.list_property' | translate }}</ion-button>
  </ion-row>
</div>
